<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img v-if="config.images.logoImage" :src="config.images.logoImage" class="sidebar-logo">
        <h1 v-else class="sidebar-title">{{ config.platformName }} </h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="config.images.logoImage" :src="config.images.logoImage" class="sidebar-logo">
        <h1 class="sidebar-title">{{ config.platformName }} </h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
import config from '@/config/config.js'
import API_ENT from '@/api/api_enterprisebase';
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      config:config,
      // title: '湖南展通安培科技有限公司网络学院',
      entName: '',
      logo: 'https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png'
    }
  },
  mounted() {
    this.getEntName()
  },
  methods:{
    //获取企业名称
    getEntName() {
      let than = this;
      API_ENT.findEntById(JSON.parse(localStorage.getItem('userinfo')).enterpriseId).then(res => {
        if (res && res.code == 0) {
          than.entName = res.ent.companyName;
          console.log(than.entName)
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #2179FE;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Logo.vue